package com.anjuros.website.templates.template5.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.EventListener

@Composable
fun Template5ObserverViewportEntered(
    sectionId:String,
    distanceFromTop:Double,
    onViewportEnteredLambda:()->Unit
){

    var viewportEntered by remember { mutableStateOf(false)}

    var listener = remember {
        EventListener {
            val top= document.getElementById(sectionId)?.getBoundingClientRect()?.top
            if(top!=null && top <distanceFromTop){
                viewportEntered=true
            }
        }
    }

    LaunchedEffect(viewportEntered){

        if(viewportEntered){
            onViewportEnteredLambda()
            window.removeEventListener(type="scroll", callback = listener)
        } else {
            window.addEventListener(type="scroll", callback = listener)
        }
    }

}


